import apiClient from './apiClient'

export const actionNames = {
  INIT_RULES: 'initRules',
  DELETE_RULE: 'deleteRule',
  ADD_RULE: 'addRule',
  UPDATE_RULE: 'updateRule'
}

export const module = {
  state: {
    rules: [],
    languages: [
      {
        name: 'Albanian',
        nickname: 'al'
      },
      {
        name: 'Bosnian',
        nickname: 'ba'
      },
      {
        name: 'Bulgarian',
        nickname: 'bg'
      },
      {
        name: 'Croatian',
        nickname: 'hr'
      },
      {
        name: 'Czech',
        nickname: 'cz'
      },
      {
        name: 'Danish',
        nickname: 'dk'
      },
      {
        name: 'Dutch',
        nickname: 'nl'
      },
      {
        name: 'English',
        nickname: 'en'
      },
      {
        name: 'Estonian',
        nickname: 'et'
      },
      {
        name: 'Finnish',
        nickname: 'fi'
      },
      {
        name: 'French',
        nickname: 'fr'
      },
      {
        name: 'Georgian',
        nickname: 'ge'
      },
      {
        name: 'German',
        nickname: 'de'
      },
      {
        name: 'Greek',
        nickname: 'gr'
      },
      {
        name: 'Hebrew',
        nickname: 'he'
      },
      {
        name: 'Hindi',
        nickname: 'hi'
      },
      {
        name: 'Hungarian',
        nickname: 'hu'
      },
      {
        name: 'Indonesian',
        nickname: 'id'
      },
      {
        name: 'Italian',
        nickname: 'it'
      },
      {
        name: 'Latvian',
        nickname: 'lv'
      },
      {
        name: 'Malaysian',
        nickname: 'my'
      },
      {
        name: 'Norwegian',
        nickname: 'no'
      },
      {
        name: 'Polish',
        nickname: 'pl'
      },
      {
        name: 'Portuguese',
        nickname: 'pt'
      },
      {
        name: 'Romanian',
        nickname: 'ro'
      },
      {
        name: 'Russian',
        nickname: 'ru'
      },
      {
        name: 'Serbian',
        nickname: 'sr'
      },
      {
        name: 'Slovak',
        nickname: 'sk'
      },
      {
        name: 'Slovenian',
        nickname: 'si'
      },
      {
        name: 'Spanish',
        nickname: 'es'
      },
      {
        name: 'Swedish',
        nickname: 'se'
      },
      {
        name: 'Turkish',
        nickname: 'tr'
      },
      {
        name: 'Ukrainian',
        nickname: 'ua'
      }
    ]
  },
  mutations: {
    setRules (state, rules) {
      state.rules = rules
    },
    addRule (state, newRule) {
      state.rules = [...state.rules, newRule]
    },
    updateRule (state, updatedRule) {
      state.rules = state.rules.map((r) => {
        if (r.id === updatedRule.id) {
          return updatedRule
        } else {
          return r
        }
      })
    },
    deleteRuleById (state, ruleIdToDelete) {
      state.rules = state.rules.filter(r => r.id !== ruleIdToDelete)
    }
  },
  actions: {
    async [actionNames.INIT_RULES] ({ commit, rootState }) {
      commit('setRules', await apiClient.getRules(rootState.auth.clientId))
    },
    async [actionNames.ADD_RULE] ({ commit, rootState }, { phrase, score, stemmed, lang, projects, shouldAdd = true }) {
      const response = await apiClient.addRule(rootState.auth.clientId, phrase, parseFloat(score), stemmed, lang, projects)
      if (shouldAdd) {
        commit('addRule', response)
      }
      return response
    },
    async [actionNames.UPDATE_RULE] ({ commit, rootState }, { id, score, projects }) {
      commit('updateRule', await apiClient.updateRule(rootState.auth.clientId, id, parseFloat(score), projects))
    },
    async [actionNames.DELETE_RULE] ({ commit, rootState }, id) {
      await apiClient.deleteRule(rootState.auth.clientId, id)
      commit('deleteRuleById', id)
    }
  }
}
